{
  "toast": {
    "experimentCreated": "Experiment created",
    "winnerDeclared": "Winner declared",
    "marketingCampaignRegistered": "Marketing campaign registered",
    "enrichmentAppliedFromEmailDomain": "Enrichment applied from email domain",
    "formCreatedAndPublishedSuccessfully": "Form created and published successfully!",
    "formArchived": "Form archived",
    "landingPageCreatedPublished": "Landing page created & published",
    "routingRuleSaved": "Routing rule saved",
    "leadScoringRuleSaved": "Lead scoring rule saved",
    "sourceCreated": "Source created"
  },
  "errors": {
    "nameAndSlugRequired": "Name and slug required",
    "failedToLoadExperiments": "Failed to load experiments",
    "failedToLoadLandingPages": "Failed to load landing pages",
    "createFailed": "Create failed",
    "failedToDeclareWinner": "Failed to declare winner",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToCreateCampaign": "Failed to create campaign",
    "failedToLoadConsentLogs": "Failed to load consent logs",
    "crmLeadIdAndEmailRequired": "CRM lead ID and email required",
    "noEnrichmentForThisLeadYet": "No enrichment for this lead yet",
    "enrichmentFailed": "Enrichment failed",
    "failedToLoadForms": "Failed to load forms",
    "failedToCreateForm": "Failed to create form",
    "failedToUpdateForm": "Failed to update form",
    "failedToDeleteForm": "Failed to delete form",
    "failedToCreateLandingPage": "Failed to create landing page",
    "formNotFound": "Form not found",
    "submissionFailed": "Submission failed",
    "validationFailed": "Validation failed",
    "missingRequiredField": "Missing required field: {{field}}",
    "failedToLoadReports": "Failed to load reports",
    "failedToLoadRoutingRequirements": "Failed to load routing requirements",
    "failedToCreateRoutingRule": "Failed to create routing rule",
    "failedToLoadScoringRules": "Failed to load scoring rules",
    "failedToCreateScoringRule": "Failed to create scoring rule",
    "failedToLoadSources": "Failed to load sources",
    "failedToCreateSource": "Failed to create source",
    "failedToLoadVisitorProfiles": "Failed to load visitor profiles"
  },
  "pages": {
    "aBLandingTests": "A/B landing tests",
    "trafficSplitExperimentsAcrossLandingPage": "Traffic-split experiments across landing page variants",
    "marketingCampaignsRoi": "Marketing Campaigns & ROI",
    "linkAdvertisingCostsUtmParametersAnd": "Link advertising costs, UTM parameters, and multi-touch revenue attribution modeling.",
    "gdprConsentTracking": "GDPR & Consent Tracking",
    "configurePrivacyBannersTrackPolicyConsent": "Configure privacy banners, track policy consent versions, and audit user acceptance logs.",
    "leadGenDashboard": "Lead Gen Dashboard",
    "additionalMetrics": "Additional metrics",
    "totalVisitors": "Total visitors",
    "conversions": "Conversions",
    "avgLeadScore": "Avg. lead score",
    "inboundAcquisitionFunnel": "Inbound acquisition funnel",
    "leadScoreDistribution": "Lead score distribution",
    "campaignRoi": "Campaign ROI",
    "visitorTrackingFormsScoringAndCrm": "Visitor tracking, forms, scoring, and CRM conversion in your scope",
    "leadEnrichment": "Lead enrichment",
    "domainInferenceAndFirmographicHintsRuns": "Domain inference and firmographic hints — runs automatically on form submit; manual refresh here",
    "acquisitionLeadForms": "Acquisition Lead Forms",
    "visualFormBuilderAndSecureEmbedding": "Visual Form Builder and secure embedding configurations.",
    "landingPageBuilder": "Landing Page Builder",
    "launchHighConvertingLandingPagesWith": "Launch high-converting landing pages with native A/B testing and custom domain support.",
    "leadGenReports": "Lead Gen Reports",
    "leadSourceReport": "Lead Source Report",
    "campaignReport": "Campaign Report",
    "conversionReport": "Conversion Report",
    "scoringReport": "Scoring Report",
    "attributionReport": "Attribution Report",
    "roiReport": "ROI Report",
    "leadSourceCampaignConversionScoringAttribution": "Lead source, campaign, conversion, scoring, attribution, and ROI analytics.",
    "leadRoutingTerritories": "Lead Routing & Territories",
    "configureAutomatedAssignmentCriteriaByCountry": "Configure automated assignment criteria by country, region, state, or product, with integrated round-robin distribution.",
    "leadScoringGrading": "Lead Scoring & Grading",
    "establishScoringThresholdsAndAssignQuality": "Establish scoring thresholds and assign quality grades (A+, A, B, C, D) based on visitor events and profiles.",
    "leadSources": "Lead Sources",
    "acquisitionChannelCatalogWebsiteAdsSocial": "Acquisition channel catalog — website, ads, social, partner portal, and API imports.",
    "visitorSessionTracking": "Visitor Session Tracking",
    "monitorAnonymousVisitorPathsReferrersAnd": "Monitor anonymous visitor paths, referrers, and cookie IDs prior to lead conversion.",
    "leadAdWebhooks": "Lead ad webhooks",
    "facebookAndGoogleLeadAdsPost": "Facebook and Google Lead Ads POST into LeadIntakeService — same path as form submissions"
  },
  "labels": {
    "experimentName": "Experiment name",
    "slug": "Slug",
    "variantPageIdsComma": "Variant page IDs (comma)",
    "trafficWeights": "Traffic weights",
    "campaignName": "Campaign Name",
    "adPlatformChannel": "Ad Platform / Channel",
    "allocatedBudgetInr": "Allocated Budget (INR)",
    "actualCostInr": "Actual Cost (INR)",
    "revenueAttributedInr": "Revenue Attributed (INR)",
    "attributionModel": "Attribution Model",
    "eGQ2EnterpriseCloudPromo": "e.g. Q2 Enterprise Cloud Promo",
    "eGLinkedinAds": "e.g. LinkedIn Ads",
    "bannerTextCookieConsent": "Banner Text (Cookie Consent)",
    "privacyStatementForms": "Privacy Statement (Forms)",
    "crmLeadId": "CRM lead ID",
    "emailForDomainEnrich": "Email (for domain enrich)",
    "formName": "Form Name",
    "description": "Description",
    "captureType": "Capture Type",
    "fieldLabel": "Field Label",
    "fieldType": "Field Type",
    "optionsCommaSeparated": "Options (Comma separated)",
    "eGInboundDemoRequest": "e.g. Inbound Demo Request",
    "optionalInternalDescription": "Optional internal description...",
    "eGOrganizationName": "e.g. Organization Name",
    "eGSmallMediumEnterprise": "e.g. Small, Medium, Enterprise",
    "pageTitle": "Page Title",
    "urlSlug": "URL Slug",
    "customDomain": "Custom Domain",
    "aBVariant": "A/B Variant",
    "landingPageTemplate": "Landing Page Template",
    "eGFreeEnterpriseAuditTrial": "e.g. Free Enterprise Audit Trial",
    "eGEnterpriseAudit": "e.g. enterprise-audit",
    "eGPromoMycompanyCom": "e.g. promo.mycompany.com",
    "ruleName": "Rule Name",
    "priorityOrder": "Priority Order",
    "assignToEmployee": "Assign to employee",
    "teamQueueCodeOptional": "Team / Queue Code (Optional)",
    "crmTerritoryOptional": "CRM territory (optional)",
    "eGIndiaRegionRouting": "e.g. India Region Routing",
    "leaveBlankForRoundRobinQueue": "Leave blank for round-robin queue",
    "eGInSalesTeam": "e.g. IN_SALES_TEAM",
    "none": "— None —",
    "scoreDeltaPoints": "Score Delta (Points)",
    "triggerEvent": "Trigger Event",
    "eGEnterpriseIndustryMatch": "e.g. Enterprise Industry Match",
    "eG15Or10": "e.g. 15 or -10",
    "code": "Code",
    "name": "Name",
    "partnerXReferrals": "Partner X Referrals"
  },
  "formActions": {
    "saveRoutingPolicy": "Save Routing Policy",
    "saveCampaign": "Save Campaign",
    "addSource": "Add Source",
    "saveScoringRule": "Save Scoring Rule",
    "addField": "Add Field",
    "saveAndPublishForm": "Save & Publish Form"
  },
  "listActions": {
    "createExperiment": "Create experiment",
    "getEmbedCode": "Get Embed Code",
    "publishLandingPage": "Publish Landing Page"
  }
}
